<template>
  <div class="header-main">
    <div class="header-links">
      <div class="links">
        <p
          v-for="(item, index) in linkItems"
          :key="index"
          :class="{ active: activeIndex === index }"
          @click="setActive(index)"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <div>
      <component :is="activeComponent" />
    </div>
    <Footer/>
  </div>
</template>

<script>
import "../../../public/css/main.css";
import ProfileForm from "./ProfileForm.vue";
import PasswordView from "./PasswordView.vue";
import MyAdds from "./MyAdds.vue";
import Footer from './footer.vue'
export default {
  components: {
    ProfileForm,
    PasswordView,
    MyAdds,
    Footer
  },
  data() {
    return {
      linkItems: ["Profile", "My Post", "Password"],
      activeIndex: 0,
    };
  },
  computed: {
    activeComponent() {
      switch (this.activeIndex) {
        case 0:
          return "ProfileForm";
        case 1:
          return "MyAdds";
        case 2:
          return "PasswordView";
        default:
          return "ProfileForm";
      }
    },
  },
  methods: {
    setActive(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped>
.header-main {
  width: 100%;
  max-width: 1440px;
  padding: 0;
  margin: 0 auto;
}

.header-links {
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 1440px;
  padding: 0 80px;
  margin: 0 auto;
  border-bottom: 1px solid #f0f1f5;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 1px 0 #f0f1f5;
}

.links {
  display: flex;
  gap: 4px;
  align-items: stretch;
}

.links p {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  padding: 14px 16px;
  border-radius: 0;
  cursor: pointer;
  transition: color 0.18s ease, border-color 0.18s ease;
  margin: 0;
  position: relative;
  border-bottom: 2.5px solid transparent;
  white-space: nowrap;
}

.links p::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2.5px;
  background: linear-gradient(90deg, #3467d5 0%, #5b87f0 100%);
  border-radius: 2px 2px 0 0;
  transform: scaleX(0);
  transition: transform 0.2s ease;
}

.links p.active {
  color: #3467d5;
  font-weight: 600;
  border-bottom-color: transparent;
}

.links p.active::after {
  transform: scaleX(1);
}

.links p:hover:not(.active) {
  color: #374151;
  background: #f8f9fc;
}

@media (max-width: 480px) {
  .header-links {
    width: 100%;
    padding: 0 12px !important;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .header-links::-webkit-scrollbar {
    display: none;
  }
  .links p {
    padding: 12px 14px;
    font-size: 13px;
  }
}
</style>
